import React, {useEffect, useRef, useState} from 'react'
import Draggable from 'react-draggable';
import {connect} from "react-redux";
import * as recorderActions from './actions';
import html2canvas from "html2canvas";
import RecordRTC from 'recordrtc'
import {bindActionCreators} from "redux";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {showIssueDialog} from "../../AppWrapper/contents/actions";
import {Button, OverlayTrigger, Tooltip} from "react-bootstrap";
import {faCheck, faPause, faPlay, faTimes} from "@fortawesome/free-solid-svg-icons";
import './Issues.css'


const actions = {...recorderActions, showIssueDialog}


const RecorderToolbar = ({name, actions, recorder}) => {
    const [isPaused, setIsPaused] = useState(false)
    const {stopRecording, setRecordingVideo, showIssueDialog, uploadFiles, getIssueMedia} = actions
    const recorderRef = useRef(null);

    const streamRef = useRef(null);
    const audioRef = useRef(null);
    const mixedStreamRef = useRef(null);

    useEffect(() => {
        handleRecording()
    }, [])

    const cleanupStreams = () => {
        if (audioRef.current) {
            audioRef.current.getTracks().forEach(track => track.stop());
        }
        if (streamRef.current) {
            streamRef.current.getTracks().forEach(track => track.stop());
        }
        if (mixedStreamRef.current) {
            mixedStreamRef.current.getTracks().forEach(track => track.stop());
        }
    }

    const setupStream = async () => {
        try {
            if (recorder.current_tab) {
                streamRef.current = await navigator.mediaDevices.getDisplayMedia({video: true, preferCurrentTab: true})
            } else {
                streamRef.current = await navigator.mediaDevices.getDisplayMedia({video: true})
            }
            audioRef.current = await navigator.mediaDevices.getUserMedia({
                audio: {
                    echoCancellation: true,
                    noiseSuppression: true,
                    sampleRate: 44100
                }
            })
        } catch (err) {
            if (!streamRef.current) {
                runIssueDialog(false)
                stopRecording()
            }
        }
    }

    const onStartStream = (type) => {
        recorderRef.current = new RecordRTC(type);
        recorderRef.current.startRecording();
        type.getVideoTracks()[0].addEventListener('ended', () => {
            handleFinish();
        });
    }

    const handleRecording = async () => {
        await setupStream()

        if (streamRef.current && audioRef.current) {
            mixedStreamRef.current = new MediaStream([...streamRef.current.getTracks(), ...audioRef.current.getTracks()]);
            onStartStream(mixedStreamRef.current)
        } else if (streamRef.current) {
            onStartStream(streamRef.current)
        }
    }

    const handleFinish = () => {
        recorderRef.current.stopRecording(() => {
            const file = recorderRef.current.getBlob()
            const content = {
                id: null,
                name: 'blob',
                size: file.size,
                type: file.type,
                url: URL.createObjectURL(file),
                file: file
            };
            setRecordingVideo([content]);
            recorderRef.current.destroy()
            runIssueDialog(false)
            cleanupStreams()
            stopRecording()
        });
    }

    const handlePause = () => {
        setIsPaused(true)
        recorderRef.current.pauseRecording(() => setIsPaused(recorderRef.current.getState()))
    };

    const handleResume = () => {
        setIsPaused(false)
        recorderRef.current.resumeRecording();
    }

    const handleReset = () => {
        recorderRef.current.reset();
        cleanupStreams();
        stopRecording()
        runIssueDialog(false)
    }

    const excludeScreenElements = () => {
        const classNames = ['.gm-control-active', '.gm-svpc', '.gmnoprint', '#recorder-toolbar']

        classNames.map(className => {
            const elements = document.querySelectorAll(className)
            return [...elements].map(element => element.setAttribute('data-html2canvas-ignore', 'true'))
        })
    }

    const runIssueDialog = (setFile = true) => {
        excludeScreenElements()

        if (setFile) {
            html2canvas(document.body, {
                useCORS: true, onclone: document => {
                    const pagination = document.querySelector('.react-bs-table-pagination')
                    if (pagination) pagination.style.bottom = '-30px'
                }
            }).then(canvas => {
                canvas.toBlob((blob) => {
                    URL.createObjectURL(blob);
                    const file = new File([blob], 'screenshot.png', blob)
                    showIssueDialog(file);
                });
            });
        } else {
            showIssueDialog(null);
        }
    }

    const setUserInitials = (name) => {
        const splittedName = name.split(" ")
        let initials = 'ME'

        if (splittedName?.length > 1) initials = `${splittedName[0].charAt(0)}${splittedName[1].charAt(0)}`
        return initials
    }

    const renderTooltip = (text) => (
        <Tooltip id="tooltip">
            <span>{text}</span>
        </Tooltip>
    );

    const renderBarButton = (icon, text, onClick, className) => (
        <OverlayTrigger placement='top' overlay={renderTooltip(text)}>
            <Button className={`recorder-btn ${className}-btn`} onClick={onClick}>
                <FontAwesomeIcon icon={icon} className="mr-9 font16"/>
            </Button>
        </OverlayTrigger>
    )

    const finishDescription = 'Finish Recording'
    const cancelDescription = 'Cancel Recording'
    const resumeDescription = isPaused ? 'Resume Recording' : 'Pause Recording'

    const resumeIcon = isPaused ? faPlay : faPause
    const resumeFunc = isPaused ? handleResume : handlePause

    return (
        <Draggable bounds="body">
            <div id='recorder-toolbar'>
                <div className='recorder-toolkit-wrapper'>
                    <div className='recorder-user-avatar'>{setUserInitials(name)}</div>
                    <div className='recorder-tools'>
                        {renderBarButton(faTimes, cancelDescription, handleReset, 'reset')}
                        {renderBarButton(resumeIcon, resumeDescription, resumeFunc, 'resume')}
                        {renderBarButton(faCheck, finishDescription, handleFinish, 'finish')}
                    </div>
                </div>
            </div>
        </Draggable>
    )
}

const mapStateToProps = state => ({
    name: state.auth.name,
    recorder: state.recorder
})

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(actions, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(RecorderToolbar)